/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { FETCH_COMMISIONINGS_TYPES_REQUEST, success, failure } from './action';

const fetchCommissioningTypes = (action$, state$, { AjaxRequest }) =>
  action$
    .ofType(FETCH_COMMISIONINGS_TYPES_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(() =>
      AjaxRequest.open(
        'get',
        '/admin/commissioningcustom/commissionings/types',
      )('tudo')
        .flatMap(({ response }) => Observable.of(success(response.resource)))
        .catch((err) => Observable.of(failure(err))),
    );

export default combineEpics(fetchCommissioningTypes);
